import { render } from "./DetalleSinAseguradora.vue?vue&type=template&id=81121c86&scoped=true"
import script from "./DetalleSinAseguradora.vue?vue&type=script&lang=js"
export * from "./DetalleSinAseguradora.vue?vue&type=script&lang=js"

import "./DetalleSinAseguradora.vue?vue&type=style&index=0&id=81121c86&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81121c86"]])

export default __exports__